export const AnalyticsEvent = {
  AuthenticationCompleted: 'authentication_completed',
};

export type AnalyticsEvents =
  typeof AnalyticsEvent[keyof typeof AnalyticsEvent];
